module.exports = __webpack_public_path__ + "img/3_0220.cc89cef.png";